module.exports = __webpack_public_path__ + "static/img/tj3.4b6528d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj3.png
// module id = dZRX
// module chunks = 0